module.exports = __webpack_public_path__ + "img/nanleAppImage.62c21e7a.png";